import React from "react";
import { Card } from "primereact/card";
import { FaFileAlt } from "react-icons/fa";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

function Right_Pannel() {
  return (
    <div className="pb-4 md:pt-6 pt-2 px-4 rounded">
      <div className="bg-white px-2 md:px-4 md:w-52 shadow-md py-4 rounded-md">
        <div className="flex flex-col space-y-2 ">
          <p className="text-gray-500 font-semibold text-2xl">
            Let's Create Something Amazing Together!{" "}
          </p>
          <p className="text-yellow-400 font-semibold text-2xl">
            {" "}
            Ready to bring my skills and passion to your team.
          </p>
          {/* Resume */}
          <div className="flex items-center "></div>
          <a
            href="https://drive.google.com/file/d/1IDZxfadbKw5C95jgWUG5jPwYDGFE1B6Z/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-blue-800 text-xl  hover:underline font-semibold"
          >
            <FaFileAlt />
            Resume
          </a>
          <div />
          <div className="flex items-center ">
            {/* Cover Letter */}
            <a
              href="https://docs.google.com/document/d/1X7ZDrVWDXVd-lGbswzGQ-KfhvZYVSpH7WENDFTMoKMg/edit?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-blue-600 text-xl hover:underline font-semibold"
            >
              <FaFileAlt />
              Cover Letter
            </a>
          </div>
        </div>
        <div className="flex justify-evenly items-center px-4 py-2 space-x-4 mt-4">
          <a
            href="https://github.com/Sri-Akshat5"
            target="_blank"
            className="text-3xl text-gray-600 hover:text-black transition-colors"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/sriakshat5/"
            target="_blank"
            className="text-3xl text-blue-600 hover:text-blue-800 transition-colors"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://x.com/sri_akshat05"
            target="_blank"
            className="text-3xl text-black hover:text-blue-600 transition-colors"
            aria-label="Twitter"
          >
            <FaXTwitter />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Right_Pannel;
